export default (slidesCount) => ({
  gallery: null,
  swiper: null,
  activeVideo: null, // Track the active video element
  activeBullet: 0, // Track the active bullet index
  settings: {
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    spaceBetween: 0,
    autoHeight: true,
    lazy: {
      loadPrevNext: true,
      loadOnTransitionStart: true,
    },
  },

  init() {
    this.$nextTick(() => {
      // Use `$nextTick` to ensure the DOM is updated before initializing Swiper
      this.gallery = this.$refs.carousel;

      // Only initialize if it doesn't already exist, and store carousel as an instance for further interaction
      if (!this.swiper) {
        this.swiper = new window.Swiper(this.gallery, {
          ...this.settings,
          on: {
            slideChange: () => {
              if (!this.swiper) return; // Guard against null during init
              this.activeBullet = this.swiper.realIndex % slidesCount;
              this.controlVideo();
            },
          },
        });
      }
    });
  },

  controlVideo() {
    this.$nextTick(() => {
      if (this.activeVideo) {
        this.activeVideo.pause(); // Pause the previous video
      }

      const activeSlide = this.swiper.slides[this.swiper.activeIndex];
      const video = activeSlide?.querySelector("video");

      if (video) {
        this.activeVideo = video;
        video.play(); // Play new active video
      }
    });
  },
});
